module.exports = __webpack_public_path__ + "static/media/Lato-Regular.3b9b9903.ttf";